module.exports = __webpack_public_path__ + "img/t_chess.8166c05.webp";